"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var getOperatorEscalationUrl_1 = require("./getOperatorEscalationUrl");
exports.AnswerActions = function (_a) {
    var className = _a.className, cardId = _a.cardId, actions = _a.actions, answers = _a.answers, selectionPath = _a.selectionPath, operatorEscalationKeyword = _a.operatorEscalationKeyword, onActionSelected = _a.onActionSelected, karakuriWebRootUrl = _a.karakuriWebRootUrl, session = _a.session;
    return actions && actions.actions ? (react_1.default.createElement(react_1.default.Fragment, null, actions.actions.map(function (action) {
        if (!action) {
            return null;
        }
        var id = action.id || '';
        if (action.label.includes(operatorEscalationKeyword)) {
            var url = getOperatorEscalationUrl_1.getOperatorEscalationUrl(cardId, answers || [], selectionPath, karakuriWebRootUrl, operatorEscalationKeyword, session);
            return (react_1.default.createElement(core_1.Button, { key: id, fullWidth: true, variant: "contained", color: "secondary", className: clsx_1.default('faq-button', className), href: url, target: "chat" }, action.label));
        }
        var unselected = !selectionPath.includes(id) && actions.actions.some(function (x) { return selectionPath.includes(x.id); });
        return (react_1.default.createElement(core_1.Button, { key: id, fullWidth: true, variant: "contained", color: "secondary", className: unselected
                ? clsx_1.default('faq-button', 'faq-button-unselected', className)
                : selectionPath.includes(id)
                    ? clsx_1.default('faq-button', 'faq-button-selected', className)
                    : clsx_1.default('faq-button', className), onClick: function (e) { return onActionSelected(e, action.id, action.external); } },
            react_1.default.createElement(core_1.Typography, { color: unselected ? 'textSecondary' : 'inherit', variant: "inherit" },
                action.label,
                selectionPath.includes(id) ? react_1.default.createElement(icons_1.Done, { fontSize: "small" }) : null,
                action.external ? react_1.default.createElement(icons_1.OpenInNew, { fontSize: "small" }) : null)));
    }))) : null;
};
//# sourceMappingURL=AnswerActions.js.map